var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgQuestion(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 24 40' }, props),
        React.createElement("path", { fillRule: 'evenodd', d: 'M9.832 30.705v-7.48c4.437-.037 7.893-1 10.368-2.887 2.475-1.889 3.712-4.905 3.712-9.048 0-3.3-1.035-5.93-3.107-7.893C18.733 1.436 15.993.455 12.582.455c-2.273 0-4.317.43-6.132 1.293-1.815.861-3.236 2.099-4.263 3.712C1.161 7.073.647 8.962.647 11.125h2.366c0-2.567.88-4.638 2.64-6.215 1.76-1.577 4.051-2.365 6.875-2.365 2.75 0 4.922.78 6.517 2.337 1.595 1.559 2.392 3.695 2.392 6.408 0 3.923-1.164 6.59-3.492 8.003-2.328 1.411-5.38 2.117-9.158 2.117h-1.32v9.295h2.365zM10.657 40v-3.795H6.752V40h3.905z' })));
}
export default SvgQuestion;
//# sourceMappingURL=Question.js.map